/* Component Dependencies */
var genericModuleLinkTemplate = require('templates/genericModuleLink.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'genericModuleLink',
    template: {
        'genericModuleLink': genericModuleLinkTemplate
    }
});